.grid {
    display: grid;
    gap: 20px;
    grid-template-rows: repeat(3, calc((100vw - 4em - 40px) / 3));
    grid-template-columns: repeat(3, calc((100vw - 4em - 40px) / 3));
}

.grid > div {
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 600;
    font-size: 1.4em;
    box-shadow: 1px 1px 3px #00000029;
}

.grid > div.error {
    background: #FF5353;
    color: white;
}

.grid > div.success {
    background: #7BB40E;
    color: white;
}